import type { CSSProperties } from 'react';
import type { IconType } from 'react-icons';

export function ProgressBar({
  percentage,
  Icon,
}: {
  percentage: number;
  Icon?: IconType;
}) {
  return (
    <div className="col-span-1 mx-auto h-1 w-full max-w-[480px] bg-grey-dark rounded-full relative">
      <div
        style={{ '--percent': `${percentage}%` } as CSSProperties}
        className="h-full w-(--percent) bg-orange rounded-full"
      />
      {Icon && (
        <Icon
          style={{ '--percent': `${percentage}%` } as CSSProperties}
          className="absolute -translate-y-1/2 translate-x-[-50%] top-1/2 left-(--percent) text-black dark:text-white"
        />
      )}
    </div>
  );
}
